import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b0810e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input_field" }
const _hoisted_2 = ["name", "type", "disabled", "readonly", "max", "min", "step", "placeholder", "data-test", "label"]

import { ref, computed, withDefaults, nextTick, watch } from 'vue'
import { configure, useField } from 'vee-validate'

type PropsType = {
  modelValue: string | number | null
  type?: string
  klass?: string
  name?: string
  rule?: string
  placeholder?: string
  disabled?: boolean
  readonly?: boolean
  nameAs?: string
  setFocusState?: boolean
  validateOn?: string
  showErrorMsg?: boolean
  max?: number
  min?: number
  step?: string | number
  dataTest?: string
  isValid?: boolean
  error?: string | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InputField',
  props: {
    modelValue: { default: null },
    type: { default: 'text' },
    klass: { default: 'default' },
    name: { default: 'input' },
    rule: null,
    placeholder: null,
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    nameAs: null,
    setFocusState: { type: Boolean, default: false },
    validateOn: null,
    showErrorMsg: { type: Boolean, default: true },
    max: null,
    min: null,
    step: null,
    dataTest: null,
    isValid: { type: Boolean, default: true },
    error: null
  },
  emits: ["update:modelValue", "update:isValid", "update:error"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', inputValue: string | number | null): void
  (e: 'update:isValid', isValid: boolean): void
  (e: 'update:error', error: string | undefined): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: string | number | null, type: string, klass: string, name: string, rule?: string, placeholder?: string, disabled: boolean, readonly: boolean, nameAs?: string, setFocusState: boolean, validateOn?: string, showErrorMsg: boolean, max?: number, min?: number, step?: string | number, dataTest?: string, isValid: boolean, error?: string | null };





const { meta, errorMessage } = useField(props.name, props.rule, { label: props.nameAs })
const input = ref<HTMLImageElement>()

configure({
  // TODO Vue3 update 動作確認ともっと使いやすく変更が必要
  validateOnBlur: props.validateOn === 'blur',
})

const inputValue = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit('update:modelValue', value)
  },
})

watch(meta, () => {
  if (meta.validated) {
    emit('update:isValid', meta.valid)
  }
})

watch(errorMessage, () => {
  emit('update:error', errorMessage.value)
})

if (props.setFocusState) {
  nextTick(() => {
    input.value?.focus()
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(inputValue) ? (inputValue).value = $event : null)),
      name: __props.name,
      class: _normalizeClass(__props.klass),
      type: __props.type,
      disabled: __props.disabled,
      readonly: __props.readonly,
      max: __props.max,
      min: __props.min,
      step: __props.step,
      placeholder: __props.placeholder,
      "data-test": __props.dataTest,
      label: __props.nameAs,
      ref_key: "input",
      ref: input
    }, null, 10, _hoisted_2), [
      [_vModelDynamic, _unref(inputValue)]
    ]),
    _withDirectives(_createElementVNode("span", {
      class: _normalizeClass(`error_${__props.klass}`)
    }, _toDisplayString(_unref(errorMessage)), 3), [
      [_vShow, _unref(errorMessage) && __props.showErrorMsg]
    ])
  ]))
}
}

})